import { useQuery } from '@tanstack/react-query';
import { auditoriaApi } from '../api/auditoria';
import type { AuditoriaFiltros } from '../types/auditoria';

const STALE_DROPDOWN = 5 * 60 * 1000; // 5 min — tipos/usuários distintos mudam pouco

export function useAuditoria(filtros: AuditoriaFiltros) {
  return useQuery({
    queryKey: ['auditoria', filtros],
    queryFn: () => auditoriaApi.listar(filtros),
    // Lista paginada — re-busca quando filtros mudam (queryKey muda).
    // staleTime curto pra não exibir dados velhos depois de uma ação que gera audit.
    staleTime: 10 * 1000,
  });
}

export function useAuditoriaTipos() {
  return useQuery({
    queryKey: ['auditoria', 'tipos'],
    queryFn: () => auditoriaApi.tipos(),
    staleTime: STALE_DROPDOWN,
  });
}

export function useAuditoriaUsuariosDistintos() {
  return useQuery({
    queryKey: ['auditoria', 'usuarios-distintos'],
    queryFn: () => auditoriaApi.usuariosDistintos(),
    staleTime: STALE_DROPDOWN,
  });
}

/**
 * KPIs do header da Auditoria (handoff design_handoff_sistema) — sem endpoint
 * agregado no backend, então usa o totalCount da listagem com pageSize=1
 * (consulta barata). "Alterações"/"Alertas" ficam stub até existir agregado.
 */
export function useAuditoriaKpis(desdeIso: string) {
  const eventos = useQuery({
    queryKey: ['auditoria', 'kpi', 'eventos', desdeIso],
    queryFn: () => auditoriaApi.listar({ periodoInicio: desdeIso, page: 1, pageSize: 1 }),
    staleTime: 60 * 1000,
    select: (r) => r.totalCount,
  });
  const logins = useQuery({
    queryKey: ['auditoria', 'kpi', 'logins', desdeIso],
    queryFn: () => auditoriaApi.listar({ periodoInicio: desdeIso, tipo: 'auth.login', page: 1, pageSize: 1 }),
    staleTime: 60 * 1000,
    select: (r) => r.totalCount,
  });
  return { eventos: eventos.data, logins: logins.data };
}
